import {applyReducers} from 'redux/helpers';
import * as actions from './actions';
import currentTemplate from './currentTemplate/reducer';
import {cloneDeep} from 'lodash';

export default (previousState = {}, action) => {
  const state = applyReducers({currentTemplate}, previousState, action);

  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        projectId: action.projectId,
      };
    case actions.INIT.END:
      return {
        ...state,
        templateOptions: action.templateOptions,
        itemOptions: action.itemOptions,
        categories: action.categories,
        subItemOptions: action.subItemOptions,
        templates: action.templates,
        users: action.users,
        changes: 0,
      };
    case actions.ADD.END:
      return {...state, templateOptions: action.templateOptions};
    case actions.REMOVE:
      if (state.currentTemplate.added) {
        return {
          ...state,
          templateOptions: state.templateOptions.filter(option => option.$$localId !== state.currentTemplate.$$localId)
        }
      }
      return {
        ...state,
        currentTemplate: {
          ...state.currentTemplate,
          value: {
            ...state.currentTemplate.value,
            isRemoved: true
          }
        }
      };
    case actions.INVALIDATE:
      return {
        ...state,
        templateOptions: action.templateOptions,
        changes: action.changes,
      };
    case actions.SAVE.END:

      const currentTemplate = {
        ...state.currentTemplate,
        value: {...state.currentTemplate.value, id: action.id},
        changes: 0,
        added: false
      };
      const templates = [];
      for (const template of state.templates) {
        if (template.id === currentTemplate.value.id) {
          if (!state.currentTemplate.value.isRemoved) {
            templates.push(cloneDeep(currentTemplate.value));
          }
        } else {
          templates.push(template);
        }
      }
      if(state.currentTemplate.added) {
        templates.push(cloneDeep(currentTemplate.value));
      }

      const templateOptions = [];
      for (const template of state.templateOptions) {
        if (template.$$localId === currentTemplate.$$localId) {
          if (!state.currentTemplate.value.isRemoved) {
            templateOptions.push(currentTemplate);
          }
        } else {
          templateOptions.push(template);
        }
      }
      templates.sort((a, b) => a.order - b.order);
      templateOptions.sort((a, b) => a.value.order - b.value.order);
      return {
        ...state,
        currentTemplate,
        templates,
        templateOptions,
        changes: action.changes,
        saving: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/template/reducer.js